var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaveLiftDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 51,
    viewBox: "0 0 63 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 46C3 47.1046 3.89543 48 5 48H58C59.1046 48 60 47.1046 60 46V5C60 3.89543 59.1046 3 58 3H5C3.89543 3 3 3.89543 3 5V46Z",
    fill: "url(#paint0_linear_894_7442)",
    stroke: "#D1CBCA",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_894_7442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 36L43.547 16H20.453L32 36Z",
    fill: "#FFF761"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_894_7442",
    x: 14.4531,
    y: 10,
    width: 35.0938,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0 0.380392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_894_7442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_894_7442",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_894_7442",
    x1: 31.5,
    y1: 51,
    x2: 31.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47401A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#0C0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50411D"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaveLiftDown);
export default __webpack_public_path__ + "static/media/cave-lift-down.fc64ac6c4acf4f610aaef10a78f33084.svg";
export { ForwardRef as ReactComponent };